import Cursos from '@/components/usuarios/Cursos'
import CursosView from '@/components/usuarios/CursoView'


import {requireUserAuth} from './base.js'

export default [
  {
    path: '/usuario/cursos',
    name: 'usuario-cursos',
    component: Cursos,
    beforeEnter: requireUserAuth
    
  },
  {
    path: '/usuario/curso/:id/visualizar',
    name: 'usuario-cursos-view',
    component: CursosView,
    beforeEnter: requireUserAuth
    
  },
  
]
